import React from 'react';
import { Box, Typography, Button, Chip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

export default function CourseHeader({ course, onEditClick }) {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
      <Typography variant="h4" component="h1">
        {course.title}
      </Typography>
      <Box>
        <Button
          variant="outlined"
          startIcon={<EditIcon />}
          onClick={onEditClick}
          sx={{ mr: 2 }}
        >
          Edit Course
        </Button>
        <Chip 
          label={course.status} 
          color={course.status === 'published' ? 'success' : 'default'}
        />
      </Box>
    </Box>
  );
}
